import React, { useState, useRef, useEffect } from "react";
import { IconCalendar, CrossIconXl } from "../../icons/Icons";
import CheckBoxMd from "../../components/CheckBox/CheckBoxMd";
import "react-phone-number-input/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import TagsInput from "../../components/TagsInput/TagsInput";
import { Formik, Form, Field } from "formik";
import TextArea from "../../components/FormikInputs/TaxtArea";
import TextInput from "../../components/FormikInputs/TextInput";
import { useLocation, useHistory } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import PhoneInput from "react-phone-number-input";
import { Modal, Button } from "react-bootstrap";
import {
  addUserAsync,
  getRolesAsync,
  getTimezoneAsync,
  getTeamsAsync,
  addAdminAsync,
  checkUniquenessAsync,
  checkUniquenessCompanyEmailAsync,
  checkUniquenessPersonalEmailAsync,
  checkUniquenessPhoneNumberAsync,
  updateUserAsync,
  validateHelpdeskNumberAsync,
  getUserUsageAsync,
  getUsersAsync,
  getEmploymentTypeAsync,
  checkUniquenessEmployeeIdAsync,
  getGenderTypeAsync,
  getAllDataTypeAsync,
} from "../../reducers/user-reducers";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "../../api/users-store-api";
import ToasterAlertSucces from "../../helper/ToasterAlertSucces";
import ToasterAlertError from "../../helper/ToasterAlertError";
import { ErrrorMessage } from "../../helper/ErrorMessage";
import validator from "validator";
import CheckBox from "../../components/CheckBox/CheckBox";
import { IconExclamationLg } from "../../icons/Icons";

import RestrictedPlan from "../AccountSetting/Billing/RestrictedPlan";
import {
  getSubscriptionAsync,
  getPlansAsync,
  getStorageAsync,
} from "../../reducers/subscription-reducers";
import { useDebounce } from "../../utils/hooks/useDebounce";

const AddUserEmployeeModal = ({
  handleModal,
  action,
  user,
  getUsers,
  getUserList,
  onClose,
  reloadUser,
}) => {
  const dispatch = useDispatch();

  const [isRestricted, setIsRestricted] = useState(false);
  const [userUsage, setUserUsage] = useState({});
  const subscriptionData = useSelector((state) => state.subscription);
  const { plansData, storageData } = useSelector((state) => state.subscription);

  const [optionsTeam, setOptionsTeam] = useState([]);
  const [optionsEmploymentType, setOptionsEmploymentType] = useState([]);
  const [optionsDesignation, setOptionsDesignation] = useState([]);
  const [optionsLocation, setOptionsLocation] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [optionsTimezone, setOptionsTimezone] = useState([]);
  const [optionsRole, setOptionsRole] = useState([]);
  const [optionsUser, setOptionsUser] = useState([]);

  const [selectedRole, setSelectedRole] = useState(
    optionsRole[0]?.label ? optionsRole[0]?.label : ""
  );
  const [selectedRoleId, setSelectedRoleId] = useState(
    optionsRole[0] ? optionsRole[0] : ""
  );
  const [selectedTeam, setSelectedTeam] = useState(
    optionsTeam[0] ? optionsTeam[0] : ""
  );
  const [selectedTimeZone, setSelectedTimeZone] = useState(
    optionsTimezone[0] ? optionsTimezone[0] : ""
  );
  const [selectedUserList, setSelectedUserList] = useState(
    optionsUser[0] ? optionsUser[0] : ""
  );

  const [selectedGender, setSelectedGender] = useState("");

  const [selectedEmploymentType, setSelectedEmploymentType] = useState(
    optionsEmploymentType[0] ? optionsEmploymentType[0] : ""
  );
  const [selectedDesignationType, setSelectedDesignationType] = useState(
    optionsDesignation[0] ? optionsDesignation[0] : ""
  );
  const [selectedLocationType, setSelectedLocationType] = useState(
    optionsLocation[0] ? optionsLocation[0] : ""
  );
  // console.log(selectedUserList, "selectedUserList")
  const defaultData = {
    id: "",
    userInformationId: "",
    role: selectedRole?.value ? selectedRole?.value : "",
    roleId: selectedRole?.value ? selectedRole?.value : "",
    profilePicture: "",
    name: "",
    title: selectedDesignationType?.value
      ? selectedDesignationType?.value
      : null,
    contactNo: "",
    phoneNumber: "",
    personalEmail: "",
    tags: "",
    status: 0,
    companyEmail: "",
    teamId: selectedTeam?.value ? selectedTeam?.value : "",
    timeZoneId: selectedTimeZone?.value ? selectedTimeZone?.value : "",
    reportsTo: selectedUserList?.value ? selectedUserList?.value : null,
    password: "",
    joiningDate: null,
    probationEndDate: null,
    confirmationStartDate: null,
    changePasswordFlag: true,
    inviteDate: null,
    isHelpdeskNumber: false,
    employeeId: "",
    employmentType: selectedEmploymentType?.value
      ? selectedEmploymentType?.value
      : null,
    gender: selectedGender?.value ? selectedGender?.value : null,
    location: selectedLocationType?.value ? selectedLocationType?.value : null,
  };

  const [userData, setUserData] = useState(user ? user : defaultData);
  const navigate = useHistory();
  const [formDataReady, setFormDataReady] = useState(true);
  const location = useLocation();
  const [opertionType, setooo] = useState("");
  const formRef = useRef();
  const [isUniqueTitle, setIsUniqueTitle] = useState(true);
  const [isUniqueCompanyEmail, setIsUniqueCompanyEmail] = useState(true);
  const [isUniquePersonalEmail, setIsUniquePersonalEmail] = useState(true);
  const [isUniqueEmployeeId, setIsUniqueEmployeeId] = useState(true);
  const [isUniquePhoneNumber, setIsUniquePhoneNumber] = useState(true);
  const [titleFocused, setTitleFocused] = useState(false);
  const [phoneFocused, setPhoneFocused] = useState(false);
  const rolesList = useSelector((state) => state.user.roles);
  const employmentTypes = useSelector((state) => state.user.employmentTypes);
  const genderTypes = useSelector((state) => state.user.genderTypes);
  const [helpdeskNumber, setHelpdeskNumber] = useState([]);
  const teamsList = useSelector((state) => state.user.teams);
  const timezoneList = useSelector((state) => state.user.timezone);
  const data = useSelector((state) => state.user.users);
  const [pageSize, setPageSize] = useState(100000);
  const [showHelpDeskError, setShowHelpDeskError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const allDataTypesdes = useSelector(
    (state) => state.user.allDataTypes.designation
  );
  const allDataTypesloc = useSelector(
    (state) => state.user.allDataTypes.location
  );
  const [designation, setDesignation] = useState([]);
  const [locations, setLocations] = useState([]);
const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    // console.log(action,'action');
    if (action !== "Edit") {
      getUserUsage();
      dispatch(getSubscriptionAsync());
      dispatch(getStorageAsync());
      dispatch(getPlansAsync());
    }
  }, [action]);

  useEffect(() => {
    // console.log(userUsage,'userUsage');
    // console.log(subscriptionData,'subscriptionData');
    // console.log(storageData,'storageData');
    const hasSubscriptions =
      subscriptionData?.subscriptionData?.subscriptions?.length > 0;
    const hasItems =
      subscriptionData?.subscriptionData?.subscriptions[0]?.items?.length > 0;
    if (action !== "Edit") {
      if (hasSubscriptions && hasItems) {
        let planUsers = 0;
        if (storageData?.seatQuantity) {
          console.log(storageData, "storageData");
          const isActive =
            subscriptionData?.subscriptionData?.subscriptions[0]?.status ===
            "active";
          const isTrialing =
            subscriptionData?.subscriptionData?.subscriptions[0]?.status ===
            "trialing";
          setIsRestricted(
            (isTrialing || isActive) &&
              userUsage?.usersCount >= storageData?.seatQuantity
          );
        }
      } else {
        setIsRestricted(true);
      }
    }
  }, [subscriptionData, userUsage, storageData, action]);

  const getUserUsage = () => {
    dispatch(getUserUsageAsync()).then((res) => {
      if (res.payload) {
        setUserUsage(res.payload);
      }
    });
  };

  const isRequiredToValiate = () => {
    return !(selectedRole?.label == "Admin");
  };

  const isFieldVisible = () => {
    return !(selectedRole?.label == "Admin");
  };
  function hasNumbersOrSpecialChars(value) {
    const regex = /[!@#$%^&*(),.?":{}|<>0-9]/g;
    return regex.test(value);
  }
  const userValidation = (values) => {
    let errors = {};

    if (!values.employeeId || values.employeeId.trim() === "") {
      errors.employeeId = "Employee id is required!";
    } else if (values.employeeId && !isUniqueEmployeeId) {
      errors.employeeId = "Employee id is already exist!";
    }

    if (values.joiningDate === "" || values.joiningDate === null) {
      errors.joiningDate = "User's joining date is required.";
    }
    // else
    // if (!values.joiningDate || values.joiningDate < new Date()) {
    //     errors.joiningDate = "Joining date should be in future!";
    // }

    if (!values.name || values.name.trim() === "") {
      errors.name = "Employee name is required!";
    } else if (hasNumbersOrSpecialChars(values.name)) {
      errors.name =
        "Employee name should not contain numbers or special characters!";
    }

    if (!values.phoneNumber || values.phoneNumber.trim() === "") {
      errors.phoneNumber = "A valid phone number is required!";
    } else if (
      !validator.isMobilePhone(values.phoneNumber, "any", { strictMode: false })
    ) {
      errors.phoneNumber = "Invalid phone number.";
    } else if (
      values.phoneNumber.length < 7 ||
      values.phoneNumber.length > 15
    ) {
      errors.phoneNumber = "Phone number should be between 7 and 15 digits.";
    } else if (values.phoneNumber && !isUniquePhoneNumber) {
      errors.phoneNumber = "Phone number is already exist!";
    }

    // else if (
    //   !/^[0-9]{10}$/.test(values.phoneNumber) &&
    //   isRequiredToValiate()
    // ) {
    //   errors.phoneNumber = "Invalid phone number";
    // }

    if (!values.companyEmail || values.companyEmail.trim() === "") {
      errors.companyEmail = "Company email is required!";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.companyEmail)) {
      errors.companyEmail = "Invalid email address";
    } else if (values.companyEmail && !isUniqueCompanyEmail) {
      errors.companyEmail = "Company email is already exist!";
    }

    if (!values.gender || values.gender.length === 0) {
      errors.gender =
        "Please select a gender for the new user. This field is required.";
    }

    if (!values.role || values.role.length === 0) {
      errors.role =
        "Please select a role for the new user. This field is required.";
    }

    if (
      (!values.employmentType && values.employmentType !== 0) ||
      values.employmentType.length === 0
    ) {
      errors.employmentType =
        "Please select a employment type for the new user. This field is required.";
    }

    // if (!values.location || values.location.trim() === "") {
    //   errors.location = "Location is required!";
    // }
    if (
      (!values.location && values.location !== 0) ||
      values.location.length === 0
    ) {
      errors.location = "Location is required!";
    }
    if ((!values.title && values.title !== 0) || values.title.length === 0) {
      errors.title = "Designation is required!";
    }
    // if (!values.title || values.title.trim() === "") {
    //   errors.title = "Designation is required!";
    // }

    // if (
    //   !values.personalEmail ||
    //   values.personalEmail.trim() === ""
    //   // && isRequiredToValiate()
    // ) {
    //   errors.personalEmail = "Personal email is required!";
    // } else
    // if (
    //   !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.personalEmail)
    //   // &&
    //   // isRequiredToValiate()
    // ) {
    //   errors.personalEmail = "Invalid email address";
    // } else if (values.personalEmail && !isUniquePersonalEmail) {
    //   errors.personalEmail = "Personal email is already exist!";
    // } else if (values.personalEmail === values.companyEmail) {
    //   errors.personalEmail =
    //     "The Company and Personal email addresses can't be the same. Please provide a different Personal email address.";
    // }

    if (
      !values.teamId ||
      values.teamId?.trim() === ""
      // &&
      // isRequiredToValiate()
    ) {
      errors.teamId =
        "Please assign the new user to a team. This field is mandatory.";
    }
    if (
      !values.timeZoneId ||
      values.timeZoneId.trim() === ""
      // &&
      // isRequiredToValiate()
    ) {
      errors.timeZoneIde = "Please set the timezone. This field is mandatory.";
    }

    if (selectedRole.label === "Employee") {
      if (!values.reportsTo || values.reportsTo.trim() === "") {
        errors.timeZoneIde =
          "Please assign to reporting manager. This field is mandatory.";
      }
    }

    // if (
    //   !values.tags ||
    //   values.tags.trim() === ""
    //   // && isRequiredToValiate()
    // ) {
    //   errors.tags = "Tags are required for user categorization.";
    // }

    // if ((!values.userName || values.userName.trim() === "") && isRequiredToValiate()) {
    //   errors.userName = "Username is required!";
    // }
    //  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.userName)) {
    //   errors.userName = "Invalid username";
    // }
    // else if (values.userName && !isUniqueTitle) {
    //     errors.userName = "Username is already exist!";
    //   }
    if (action !== "Edit") {
      if (!values.password) {
        errors.password = "Please enter a password to proceed.";
      } else if (values.password.length < 8) {
        errors.password =
          "A password is required and it must be at least 8 characters long.";
      } else if (
        !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
          values.password
        )
      ) {
        errors.password =
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character";
      }
    }
    if (values.inviteDate === "" || values.inviteDate === null) {
      errors.inviteDate =
        "Please specify when to send the invitation to the user.";
    }
    // else if (!values.inviteDate || values.inviteDate < new Date()) {
    //   errors.inviteDate = "Invite date should be in future!";
    // }

    console.log(errors, "errors");
    // console.log(values.joiningDate,'values.joiningDate');
    return errors;
  };

  const onUserSubmit = async (action) => {
    console.log(action, "actionaction");
    const currentFormData = formRef?.current;
    // if (currentFormData.values.status == undefined) {
    //     navigate.push("/users");
    // }
    var errors = userValidation(currentFormData.values);
    if (
      Object.keys(currentFormData.errors).length === 0 &&
      Object.keys(errors).length === 0
    ) {
      if (userData["id"] && (action === undefined || action === "edit")) {
        const reqBody = {
          id: userData?.id,
          roleId: selectedRole.value,
          roleName: selectedRole.label,
          // title: currentFormData?.values?.title,
          profilePicture: currentFormData?.values?.profilePicture ?? "",
          name: currentFormData?.values?.name,
          contactNo: currentFormData?.values?.phoneNumber,
          phoneNumber: currentFormData?.values?.phoneNumber,
          personalEmail: currentFormData?.values?.personalEmail,
          tags: currentFormData?.values?.tags,
          status: currentFormData?.values?.status,
          companyEmail: currentFormData?.values?.companyEmail,
          teamId: currentFormData?.values?.teamId,
          timeZoneId: currentFormData?.values?.timeZoneId,
          reportsTo:
            currentFormData?.values?.reportsTo === null
              ? null
              : currentFormData?.values?.reportsTo,
          // userName: currentFormData?.values?.userName,
          password: currentFormData?.values?.password,
          joiningDate: currentFormData?.values?.joiningDate,
          probationEndDate:
            selectedEmploymentType?.value === 0
              ? currentFormData?.values?.probationEndDate
              : null,
          confirmationStartDate:
            selectedEmploymentType?.value === 1
              ? currentFormData?.values?.confirmationStartDate
              : null,
          changePasswordFlag: currentFormData?.values?.changePasswordFlag,
          isHelpdeskNumber: currentFormData?.values?.isHelpdeskNumber,
          inviteDate: currentFormData?.values?.inviteDate,
          code: "",
          IdentityId: userData["identityId"],
          employeeId: currentFormData?.values?.employeeId,
          employmentType: selectedEmploymentType?.value,
          gender: selectedGender?.value,
          location: selectedLocationType?.value,
          title: selectedDesignationType?.value,
          // location: currentFormData?.values?.location,
        };
        setFormDataReady(false);
        try {
          const res = dispatch(updateUserAsync(reqBody));
          if (res) {
            setFormDataReady(true);
            // getUsers && getUsers();
            ToasterAlertSucces(res, ErrrorMessage.UPDATE);
            getUserList();
            getUsers();
            // getUsers && getUsers();
            setSelectedRoleId(rolesList[0] ? rolesList[0] : {});
            setSelectedTeam(teamsList[0] ? teamsList[0] : {});
            setSelectedTimeZone(timezoneList[0] ? timezoneList[0] : {});
            setSelectedUserList(data.users[0] ? data.users[0] : {});
            setSelectedEmploymentType(
              optionsEmploymentType[0] ? optionsEmploymentType[0] : {}
            );
            setSelectedDesignationType(
              optionsDesignation[0] ? optionsDesignation[0] : {}
            );
            setSelectedLocationType(
              optionsLocation[0] ? optionsLocation[0] : {}
            );
            setSelectedGender(genderList[0] ? genderList[0] : {});
            formRef?.current?.resetForm();
            reloadUser && reloadUser(true);
            handleModal(action === "invite");
            navigate.push("/users", { reloadUsers: true });
          } else {
            ToasterAlertError(res);
          }
        } catch (error) {
          ToasterAlertError(
            "An unexpected error occurred. Please try again later."
          );
        }

        // dispatch(updateUserAsync(reqBody)).then((res) => {
        //   getUsers()
        //   ToasterAlertSucces(res, ErrrorMessage.UPDATE);
        //   setFormDataReady(true);
        //   getUserList()
        //   if (res?.error) {
        //     console.log(res);
        //   } else {
        //     setSelectedRoleId(rolesList[0] ? rolesList[0] : {});
        //     setSelectedTeam(teamsList[0] ? teamsList[0] : {});
        //     setSelectedTimeZone(timezoneList[0] ? timezoneList[0] : {});
        //     setSelectedUserList(data.users[0] ? data.users[0] : {})
        //     formRef?.current?.resetForm();
        //     handleModal(action == "invite");
        //     navigate.push("/users");
        //   }
        // });
      } else {
        const reqBody = {
          roleId: currentFormData?.values?.role,
          roleName: selectedRole.label,
          // title: currentFormData?.values?.title,
          profilePicture: currentFormData?.values?.profilePicture ?? "",
          name: currentFormData?.values?.name,
          contactNo: currentFormData?.values?.contactNo,
          phoneNumber: currentFormData?.values?.phoneNumber,
          personalEmail: currentFormData?.values?.personalEmail,
          tags: currentFormData?.values?.tags,
          status: currentFormData?.values?.status,
          companyEmail: currentFormData?.values?.companyEmail,
          teamId: currentFormData?.values?.teamId,
          timeZoneId: currentFormData?.values?.timeZoneId,
          reportsTo:
            currentFormData?.values?.reportsTo === null
              ? null
              : currentFormData?.values?.reportsTo,
          // userName: currentFormData?.values?.userName,
          password: currentFormData?.values?.password,
          joiningDate: currentFormData?.values?.joiningDate,
          probationEndDate:
            selectedEmploymentType?.value === 0
              ? currentFormData?.values?.probationEndDate
              : null,
          confirmationStartDate:
            selectedEmploymentType?.value === 1
              ? currentFormData?.values?.confirmationStartDate
              : null,
          changePasswordFlag: currentFormData?.values?.changePasswordFlag,
          isHelpdeskNumber: currentFormData?.values?.isHelpdeskNumber,
          inviteDate: currentFormData?.values?.inviteDate,
          code: "",
          employeeId: currentFormData?.values?.employeeId,
          employmentType: selectedEmploymentType?.value,
          gender: selectedGender?.value,
          // location: currentFormData?.values?.location,
          location: selectedLocationType?.value,
          title: selectedDesignationType?.value,
        };
        setFormDataReady(false);
        if (selectedRole.label === "Admin") {
          try {
            const res = await dispatch(addUserAsync(reqBody));
            if (res) {
              ToasterAlertSucces(res, ErrrorMessage.CREATE);
              // getUsers && getUsers();
              setFormDataReady(true);
              setSelectedRoleId(rolesList[0] ? rolesList[0] : {});
              // setSelectedTeam(teamsList[0] ? teamsList[0] : {});
              // setSelectedTimeZone(timezoneList[0] ? timezoneList[0] : {});
              setSelectedEmploymentType("");
              setSelectedGender("");
              setSelectedTeam("");
              setSelectedTimeZone("");
              setSelectedUserList("");
              setSelectedDesignationType("");
              setSelectedLocationType("");
              formRef?.current?.resetForm();
              // reloadUser && reloadUser(true);
              if (action === "invite") {
                handleModal(true);
              } else {
                await navigate.push("/users", { reloadUsers: true });
                onClose(false); // This will be executed after the navigation
              }
            } else {
              console.log(res);
              ToasterAlertError(res);
            }
          } catch (error) {
            ToasterAlertError(
              "An unexpected error occurred. Please try again later."
            );
          }
        } else {
          try {
            const res = await dispatch(addUserAsync(reqBody));
            if (res) {
              ToasterAlertSucces(res, ErrrorMessage.CREATE);
              // getUsers && getUsers();
              setFormDataReady(true);
              setSelectedRoleId(rolesList[0] ? rolesList[0] : {});
              setSelectedEmploymentType("");
              setSelectedGender("");
              // setSelectedTeam(teamsList[0] ? teamsList[0] : {});
              // setSelectedTimeZone(timezoneList[0] ? timezoneList[0] : {});
              setSelectedTeam("");
              setSelectedTimeZone("");
              setSelectedUserList("");
              setSelectedDesignationType("");
              setSelectedLocationType("");
              formRef?.current?.resetForm();
              // reloadUser && reloadUser(true);
              if (action === "invite") {
                handleModal(true);
              } else {
                await navigate.push("/users", { reloadUsers: true });
                onClose(false); // This will be executed after the navigation
              }
            } else {
              console.log(res);
              ToasterAlertError(res);
            }
          } catch (error) {
            ToasterAlertError(
              "An unexpected error occurred. Please try again later."
            );
          }
        }
      }
    }
  };
  const onTagsUpdate = (
    updatedList,
    setFieldValue,
    setTouchedMethod,
    formTouchedData
  ) => {
    let stringdata = updatedList
      .map((m) => {
        return m.tag;
      })
      .toString();

    if (setTouchedMethod) {
      setTouchedMethod({ ...formTouchedData, ["tags"]: true });
    }
    setFieldValue("tags", stringdata);
  };
  const onSelectationChange = (e, colName, setMethod, localState) => {
    localState({
      value: e?.value,
      label: e?.label,
    });
    if (setMethod) {
      setMethod(colName, e.value);
    }
    if (colName === "teamId") {
      const reqBody = {
        id: userData?.id ? userData?.id : "",
        teamId: e?.value ? e?.value : "",
      };
      dispatch(validateHelpdeskNumberAsync(reqBody)).then((res) => {
        if (res.payload) {
          setHelpdeskNumber(res.payload);
          setIsVisible(true);
        }
      });
    }
  };
  const userId = user?.userInformationId;

  // useEffect(() => {
  //   const roleReqBody = {
  //     name: "",
  //   };
  //   const teamsReqBody = {};
  //   const timezoneReqBody = {};
  //   const userReqBody = {
  //     pageSize: pageSize,
  //     filters: {},
  //   };
  //   const reqBody = {
  //     page: 1,
  //     pageSize: 1000,
  //     orderBy: "CreatedOn",
  //     statusFilter: [],
  //     isOrderByDesc: true,
  //     searchString: "",
  //   };

  //   if (genderTypes.length === 0) {
  //     dispatch(getGenderTypeAsync()).then((res) => {
  //       if (res?.payload) {
  //         const genTypes = res?.payload?.map((item) => {
  //           // return { value: item.id, label: item.name };
  //           return { value: item.name, label: item.name };
  //         });
  //         setGenderList(genTypes);
  //       }
  //     });
  //   } else {
  //     if (genderTypes && genderTypes?.length > 0) {
  //       const genTypes = genderTypes?.map((item) => {
  //         return { value: item.name, label: item.name };
  //       });
  //       setGenderList(genTypes);
  //     }
  //   }

  //   if (employmentTypes.length === 0) {
  //     dispatch(getEmploymentTypeAsync()).then((res) => {
  //       if (res?.payload) {
  //         const empTypes = res?.payload?.map((item) => {
  //           return { value: item.id, label: item.name };
  //         });
  //         setOptionsEmploymentType(empTypes);
  //       }
  //     });
  //   } else {
  //     if (employmentTypes && employmentTypes?.length > 0) {
  //       const empTypes = employmentTypes?.map((item) => {
  //         return { value: item.id, label: item.name };
  //       });
  //       setOptionsEmploymentType(empTypes);
  //     }
  //   }

  //   if (rolesList.length === 0) {
  //     dispatch(getRolesAsync(roleReqBody)).then((res) => {
  //       if (!!res?.payload && res?.payload.totalRecords > 0) {
  //         const roles = res?.payload?.records.map((item) => {
  //           return { value: item.id, label: item.name };
  //         });
  //         setOptionsRole(roles);
  //       }
  //     });
  //   } else {
  //     if (!!rolesList && rolesList?.totalRecords > 0) {
  //       const roles = rolesList?.records.map((item) => {
  //         return { value: item.id, label: item.name };
  //       });
  //       setOptionsRole(roles);
  //     }
  //   }

  //   if (teamsList.length === 0) {
  //     dispatch(getTeamsAsync(teamsReqBody)).then((res) => {
  //       if (!!res?.payload && res?.payload?.length > 0) {
  //         const teams = res?.payload?.map((item) => {
  //           return { value: item.key, label: item.value };
  //         });
  //         setOptionsTeam(teams);
  //       }
  //     });
  //   } else {
  //     if (!!teamsList && teamsList?.length > 0) {
  //       const teams = teamsList?.map((item) => {
  //         return { value: item.key, label: item.value };
  //       });
  //       setOptionsTeam(teams);
  //     }
  //   }

  //   if (timezoneList.length === 0) {
  //     dispatch(getTimezoneAsync(timezoneReqBody)).then((res) => {
  //       if (!!res?.payload && res?.payload.length > 0) {
  //         const timeZone = res?.payload.map((item) => {
  //           return { value: item.key, label: item.value };
  //         });
  //         setOptionsTimezone(timeZone);
  //       }
  //     });
  //   } else {
  //     if (!!timezoneList && timezoneList?.length > 0) {
  //       const timeZone = timezoneList?.map((item) => {
  //         return { value: item.key, label: item.value };
  //       });
  //       setOptionsTimezone(timeZone);
  //     }
  //   }

  //   if (data.users?.length === 0) {
  //     dispatch(getUsersAsync(userReqBody)).then((res) => {
  //       if (!!res.payload.users && res.payload.users.length > 0) {
  //         // const users = res?.payload?.users.map((item) => {
  //         //   return { value: item.userInformationId, label: item.name };
  //         // });
  //         const users = res?.payload?.users
  //           .filter((item) => item.userInformationId !== userId)
  //           .map((item) => {
  //             return { value: item.userInformationId, label: item.name };
  //           });
  //         const optionsWithExtra = [
  //           { value: null, label: "Select...." },
  //           ...users,
  //         ];
  //         // console.log(users, "data1");
  //         setOptionsUser(optionsWithExtra);
  //       }
  //     });
  //   } else {
  //     if (!!data && data?.totalRecords > 0) {
  //       //   const users = data?.users.map((item) => {
  //       //     return { value: item.userInformationId, label: item.name };
  //       //   });
  //       //   console.log(data, "data");
  //       //  setOptionsUser(users);
  //       dispatch(getUsersAsync(userReqBody)).then((res) => {
  //         if (!!res.payload.users && res.payload.users.length > 0) {
  //           // const users = res?.payload?.users.map((item) => {
  //           //   return { value: item.userInformationId, label: item.name };
  //           // });
  //           const users = res?.payload?.users
  //             .filter((item) => item.userInformationId !== userId)
  //             .map((item) => {
  //               return { value: item.userInformationId, label: item.name };
  //             });
  //           const optionsWithExtra = [
  //             { value: null, label: "Select...." },
  //             ...users,
  //           ];
  //           //console.log(users, "data1");
  //           setOptionsUser(optionsWithExtra);
  //         }
  //       });
  //     }
  //   }
  //   if (allDataTypesdes.length === 0) {
  //     dispatch(
  //       getAllDataTypeAsync({
  //         typeName: "designation",
  //         reqBody
  //       })
  //     ).then((res) => {
  //       if (!!res?.payload && res?.payload?.records?.length > 0) {
  //         const desTypes = res?.payload?.records?.map((item) => {
  //           return { value: item.id, label: item.name };
  //         });
  //         setOptionsDesignation(desTypes);
  //         // setDesignation(res?.payload?.records);
  //       }
  //     });
  //   } else {
  //     if (!!allDataTypesdes && allDataTypesdes?.length > 0) {
  //       const desTypes = allDataTypesdes?.map((item) => {
  //         return { value: item.id, label: item.name };
  //       });
  //       setOptionsDesignation(desTypes);
  //     }
  //   }

  //   if (allDataTypesloc.length === 0) {
  //     dispatch(
  //       getAllDataTypeAsync({
  //         typeName: "location",
  //         reqBody
  //       })
  //     ).then((res) => {
  //       if (!!res?.payload && res?.payload?.records?.length > 0) {
  //         const locTypes = res?.payload?.records?.map((item) => {
  //           return { value: item.id, label: item.name };
  //         });
  //         setOptionsLocation(locTypes);
  //        // setLocations(res?.payload?.records);
  //       }
  //     });
  //   } else {
  //     if (!!allDataTypesloc && allDataTypesloc?.length > 0) {
  //       const locTypes = allDataTypesloc?.map((item) => {
  //         return { value: item.id, label: item.name };
  //       });
  //       setOptionsLocation(locTypes);
  //     }
  //   }

  //   if (action == "Edit") {
  //     console.log(user,"user123")
  //     setUserData(user);
  //     setSelectedTeam({
  //       value: user?.teamId,
  //       label: user?.team,
  //     });

  //     setSelectedRole({
  //       value: user?.roleId,
  //       label: user?.role,
  //     });

  //     setSelectedGender({
  //       value: user?.gender,
  //       label: user?.gender,
  //     })

  //     setSelectedTimeZone({
  //       value: user?.timeZoneId,
  //       label: user?.timeZoneDisplayName,
  //     });

  //     setSelectedUserList({
  //       value: user?.reportsTo,
  //       label: user?.reportsToName,
  //     });

  //     if (employmentTypes.length > 0) {
  //       const empTypes = employmentTypes.map((item) => {
  //         if (user?.employmentType === item.id) {
  //           return { value: item.id, label: item.name };
  //         }
  //         return null;
  //       }).filter(Boolean);
  //       setSelectedEmploymentType(empTypes[0] || null);
  //     }

  //     if (allDataTypesdes.length > 0) {
  //       const desTypes = allDataTypesdes.map((item) => {
  //         if (user?.title === item.name) {
  //           return { value: item.id, label: item.name };
  //         }
  //         return null;
  //       }).filter(Boolean);
  //       console.log(desTypes, "desTypes")
  //       setSelectedDesignationType(desTypes);
  //     }

  //     if (allDataTypesloc.length > 0) {
  //       const locTypes = allDataTypesloc.map((item) => {
  //         if (user?.location === item.name) {
  //           return { value: item.id, label: item.name };
  //         }
  //         return null;
  //       }).filter(Boolean);
  //       setSelectedLocationType(locTypes);
  //     }
  //   }
  // }, []);

useEffect(() => {
  const roleReqBody = { name: "" };
  const teamsReqBody = {};
  const timezoneReqBody = {};
  const userReqBody = { pageSize: pageSize, filters: {} };
  const reqBody = {
    page: 1,
    pageSize: 1000,
    orderBy: "CreatedOn",
    statusFilter: [],
    isOrderByDesc: true,
    searchString: "",
  };

  const fetchData = async () => {
    setIsLoadingData(true);
    try {
      if (genderTypes.length === 0) {
        const genderRes = await dispatch(getGenderTypeAsync());
        const genTypes = genderRes?.payload?.map((item) => ({
          value: item.name,
          label: item.name,
        }));
        setGenderList(genTypes || []);
      } else {
        const genTypes = genderTypes.map((item) => ({
          value: item.name,
          label: item.name,
        }));
        setGenderList(genTypes);
      }


      if (rolesList.length === 0) {
        const rolesRes = await dispatch(getRolesAsync(roleReqBody));
        if (rolesRes?.payload && rolesRes.payload.totalRecords > 0) {
          const roles = rolesRes.payload.records
            .filter((item) => item.name !== "No Access")
            .map((item) => ({ value: item.id, label: item.name }));
          setOptionsRole(roles);
        }
      } else {
        if (rolesList?.totalRecords > 0) {
          const roles = rolesList.records
            .filter((item) => item.name !== "No Access")
            .map((item) => ({ value: item.id, label: item.name }));
          setOptionsRole(roles);
        }
      }


      if (teamsList.length === 0) {
        const teamsRes = await dispatch(getTeamsAsync(teamsReqBody));
        if (teamsRes?.payload && teamsRes.payload.length > 0) {
          const teams = teamsRes.payload.map((item) => ({
            value: item.key,
            label: item.value,
          }));
          setOptionsTeam(teams);
        }
      } else {
        if (teamsList?.length > 0) {
          const teams = teamsList.map((item) => ({
            value: item.key,
            label: item.value,
          }));
          setOptionsTeam(teams);
        }
      }

      if (timezoneList.length === 0) {
        const timezoneRes = await dispatch(getTimezoneAsync(timezoneReqBody));
        if (timezoneRes?.payload && timezoneRes.payload.length > 0) {
          const timeZone = timezoneRes.payload.map((item) => ({
            value: item.key,
            label: item.value,
          }));
          setOptionsTimezone(timeZone);
        }
      } else {
        if (timezoneList?.length > 0) {
          const timeZone = timezoneList.map((item) => ({
            value: item.key,
            label: item.value,
          }));
          setOptionsTimezone(timeZone);
        }
      }

      const usersRes = await dispatch(getUsersAsync(userReqBody));
      if (usersRes.payload?.users && usersRes.payload.users.length > 0) {
        const users = usersRes.payload.users
          .filter((item) => item.userInformationId !== userId)
          .map((item) => ({
            value: item.userInformationId,
            label: item.name,
          }));
        const optionsWithExtra = [{ value: null, label: "Select...." }, ...users];
        setOptionsUser(optionsWithExtra);
      }

      let empOptions = [];
      if (employmentTypes.length === 0) {
        const empRes = await dispatch(getEmploymentTypeAsync());
        const empTypes = empRes?.payload?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
        setOptionsEmploymentType(empTypes);
        empOptions = empTypes;
      } else {
        const empTypes = employmentTypes.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setOptionsEmploymentType(empTypes);
        empOptions = empTypes;
      }

      let designationOptions = [];
      if (allDataTypesdes.length === 0) {
        const desRes = await dispatch(
          getAllDataTypeAsync({ typeName: "designation", reqBody })
        );
        if (desRes?.payload?.records) {
          const desTypesRaw = desRes.payload.records.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          const desTypes = desTypesRaw.filter(
            (item, idx, arr) =>
              arr.findIndex((t) => t.value === item.value) === idx
          );
          setOptionsDesignation(desTypes);
          designationOptions = desTypes;
        }
      } else {
        const desTypesRaw = allDataTypesdes.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        const desTypes = desTypesRaw.filter(
          (item, idx, arr) =>
            arr.findIndex((t) => t.value === item.value) === idx
        );
        setOptionsDesignation(desTypes);
        designationOptions = desTypes;
      }

      let locationOptions = [];
      if (allDataTypesloc.length === 0) {
        const locRes = await dispatch(
          getAllDataTypeAsync({ typeName: "location", reqBody })
        );
        if (locRes?.payload?.records) {
          const locTypesRaw = locRes.payload.records.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          const locTypes = locTypesRaw.filter(
            (item, idx, arr) =>
              arr.findIndex((t) => t.value === item.value) === idx
          );
          setOptionsLocation(locTypes);
          locationOptions = locTypes;
        }
      } else {
        const locTypesRaw = allDataTypesloc.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        const locTypes = locTypesRaw.filter(
          (item, idx, arr) =>
            arr.findIndex((t) => t.value === item.value) === idx
        );
        setOptionsLocation(locTypes);
        locationOptions = locTypes;
      }

      if (action === "Edit" && user) {
        setUserData(user);
        
        setSelectedTeam({
          value: user?.teamId,
          label: user?.team,
        });
        
        setSelectedRole({
          value: user?.roleId,
          label: user?.role,
        });
        
        setSelectedGender({
          value: user?.gender,
          label: user?.gender,
        });
        
        setSelectedTimeZone({
          value: user?.timeZoneId,
          label: user?.timeZoneDisplayName,
        });
        
        setSelectedUserList({
          value: user?.reportsTo,
          label: user?.reportsToName,
        });

        if (empOptions.length > 0 && user?.employmentType !== undefined) {
          const empType = empOptions.find(
            (item) => item.value === user.employmentType
          );
          console.log("Found employment type:", empType);
          if (empType) {
            setSelectedEmploymentType(empType);
          }
        }
        if (designationOptions.length > 0) {
          let desType = null;

          if (user?.designationId) {
            desType = designationOptions.find(
              (item) => item.value === user.designationId
            );
          }

          if (!desType && user?.title) {
            desType = designationOptions.find(
              (item) => item.label === user.title
            );
          }
           
          if (desType) {
            setSelectedDesignationType(desType);
          }
        }

        if (locationOptions.length > 0) {
          let locType = null;

          if (user?.locationId) {
            locType = locationOptions.find(
              (item) => item.value === user.locationId
            );
          }
          
          if (!locType && user?.location) {
            locType = locationOptions.find(
              (item) => item.label === user.location
            );
          } 
          if (locType) {
            setSelectedLocationType(locType);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }finally {
      setIsLoadingData(false); 
    }
  };

  fetchData();
}, [action]);

  const validateCompanyEmail = async (
    companyEmail,
    validateField,
    touchedFields,
    setTouchedFun
  ) => {
    setTouchedFun({ ...touchedFields, ["companyEmail"]: true });
    validateField("companyEmail");
    if (companyEmail.trim() !== "") {
      const jsonData = userData["userInformationId"]
        ? {
            id: userData["userInformationId"] ?? null,
            identityId: userData["identityId"] ?? null,
            email: companyEmail,
          }
        : {
            email: companyEmail,
          };

      await dispatch(checkUniquenessCompanyEmailAsync(jsonData)).then((res) => {
        setIsUniqueCompanyEmail(res?.payload ? true : false);
        setTitleFocused(false);
        setTimeout(() => {
          setTouchedFun({ ...touchedFields, ["companyEmail"]: true });
          validateField("companyEmail");
        }, 1);
      });
    }
  };
  const debouncedValidateCompanyEmail = useDebounce(validateCompanyEmail, 1000);

  const validateEmployeeId = async (
    employeeId,
    validateField,
    touchedFields,
    setTouchedFun
  ) => {
    setTouchedFun({ ...touchedFields, ["employeeId"]: true });
    validateField("employeeId");
    if (employeeId.trim() !== "") {
      const jsonData = userData["userInformationId"]
        ? {
            id: userData["userInformationId"] ?? null,
            identityId: userData["identityId"] ?? null,
            employeeId: employeeId,
            email: "",
          }
        : {
            email: "",
            employeeId: employeeId,
          };

      await dispatch(checkUniquenessEmployeeIdAsync(jsonData)).then((res) => {
        setIsUniqueEmployeeId(res?.payload ? true : false);
        setTitleFocused(false);
        setTimeout(() => {
          setTouchedFun({ ...touchedFields, ["employeeId"]: true });
          validateField("employeeId");
        }, 1);
      });
    }
  };
  const debouncedValidateEmployeeId = useDebounce(validateEmployeeId, 1000);

  const validatePersonalEmail = async (
    personalEmail,
    validateField,
    touchedFields,
    setTouchedFun
  ) => {
    setTouchedFun({ ...touchedFields, ["personalEmail"]: true });
    validateField("personalEmail");
    if (personalEmail.trim() !== "") {
      const jsonData = userData["id"]
        ? {
            id: userData["id"] ?? null,
            identityId: userData["identityId"] ?? null,
            email: personalEmail,
          }
        : {
            email: personalEmail,
          };

      await dispatch(checkUniquenessPersonalEmailAsync(jsonData)).then(
        (res) => {
          setIsUniquePersonalEmail(res?.payload ? true : false);
          setTitleFocused(false);
          setTimeout(() => {
            setTouchedFun({ ...touchedFields, ["personalEmail"]: true });
            validateField("personalEmail");
          }, 1);
        }
      );
    }
  };

  const debouncedValidatePersonalEmail = useDebounce(
    validatePersonalEmail,
    1000
  );

  const validatePhoneNumber = async (
    phoneNumber,
    validateField,
    touchedFields,
    setTouchedFun
  ) => {
    setTouchedFun({ ...touchedFields, ["phoneNumber"]: true });
    validateField("phoneNumber");
    // console.log(phoneNumber,'phoneNumber');

    // Remove spaces from the phone number
    const phoneNumberWithoutSpaces = phoneNumber.replace(/\s/g, "");

    if (phoneNumber && phoneNumber.trim() !== "") {
      const jsonData = userData["userInformationId"]
        ? {
            id: userData["userInformationId"] ?? null,
            identityId: userData["identityId"] ?? null,
            phoneNumber: phoneNumberWithoutSpaces,
          }
        : {
            phoneNumber: phoneNumberWithoutSpaces,
          };

      await dispatch(checkUniquenessPhoneNumberAsync(jsonData)).then((res) => {
        // console.log(res?.payload,'res?.payload');
        setIsUniquePhoneNumber(res?.payload ? true : false);
        setPhoneFocused(false);
        setTimeout(() => {
          setTouchedFun({ ...touchedFields, ["phoneNumber"]: true });
          validateField("phoneNumber");
        }, 1);
      });
    }
  };
  const debouncedValidatePhoneNumber = useDebounce(validatePhoneNumber, 1000);

  useEffect(() => {
    const reqBody = {
      id: userData?.id ? userData?.id : "",
      teamId: selectedTeam?.value ? selectedTeam?.value : "",
    };
    dispatch(validateHelpdeskNumberAsync(reqBody)).then((res) => {
      // console.log(res, 'res')
      if (res.payload) {
        setHelpdeskNumber(res.payload);
      }
    });
  }, []);

  useEffect(() => {
    console.log(action, "action");
    console.log(userData, "userData");
    console.log(selectedTeam, "selectedTeam");
    console.log(helpdeskNumber, "helpdeskNumber");
    if (
      action == "Edit" &&
      helpdeskNumber?.email !== userData?.companyEmail &&
      helpdeskNumber?.result === "Helpdesk with same team exist."
    ) {
      setShowHelpDeskError(true);
    } else if (
      action !== "Edit" &&
      selectedTeam?.value &&
      helpdeskNumber?.result === "Helpdesk with same team exist."
    ) {
      setShowHelpDeskError(true);
    } else {
      setShowHelpDeskError(false);
    }
  }, [userData, selectedTeam, helpdeskNumber, action]);

  const [selectedValues, setSelectedValues] = useState();
  const handleCheckboxChange = (newValues) => {
    setSelectedValues(newValues);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    userData && (
      <>
        {!isRestricted && (
          <Formik
            initialValues={{
              // id: userData?.id,
              role: userData?.role ?? undefined,
              roleId: userData?.roleId ?? undefined,
              // profilePicture: userData?.profilePicture,
              name: userData?.name,
              title: userData?.title,
              phoneNumber: userData?.phoneNumber,
              personalEmail: userData?.personalEmail,
              tags: userData?.tags,
              status: userData?.status,
              companyEmail: userData?.companyEmail,
              teamId: userData?.teamId,
              timeZoneId: userData?.timeZoneId ?? 1,
              reportsTo: userData?.reportsTo,
              // userName: userData?.userName,
              password: userData?.password,
              joiningDate: userData?.joiningDate
                ? new Date(userData?.joiningDate)
                : new Date(),
              probationEndDate: userData?.probationEndDate
                ? new Date(userData?.probationEndDate)
                : new Date(),
              confirmationStartDate: userData?.confirmationStartDate
                ? new Date(userData?.confirmationStartDate)
                : new Date(),
              changePasswordFlag: userData?.changePasswordFlag,
              isHelpdeskNumber: userData?.isHelpdeskNumber,
              inviteDate: userData?.inviteDate
                ? new Date(userData?.inviteDate)
                : new Date(),
              employeeId: userData?.employeeId,
              employmentType: userData?.employmentType,
              gender: userData?.gender,
              location: userData?.location,
            }}
            onSubmit={onUserSubmit}
            validate={userValidation}
            innerRef={formRef}
          >
            {({
              formik,
              errors,
              touched,
              isValidating,
              values,
              validateField,
              handleBlur,
              setFieldValue,
              setTouched,
            }) => {
              console.log(values, "values");
              return (
                <>
                  <Modal.Header>
                    {/* closeButton */}
                    {/* onClick={() => onClose(false)} */}
                    <div className="w-100">
                      {action == "Edit" && (
                        <Modal.Title>Edit user details</Modal.Title>
                      )}
                      {action != "Edit" && <Modal.Title>Add User</Modal.Title>}
                    </div>
                    <button
                      onClick={() => {
                        reloadUser && reloadUser(true);
                        handleModal(false);
                      }}
                      type="button"
                      class="btn-close"
                      aria-label="Close"
                    ></button>
                  </Modal.Header>
                  <Modal.Body className="">
                  {isLoadingData && <Loader type="activity" />}
                    {formDataReady === false && !isLoadingData && <Loader type="activity" />}
                    {!isLoadingData && formDataReady && (
                      <Form style={{ display: "contents" }}>
                        <div className="row">
                          <div className="col-6 col-md-6 col-lg-6">
                            {/* {action != "Edit" && ( */}
                            <div className="input-group myInput mb-32">
                              <TextInput
                                name="employeeId"
                                label="Employee ID"
                                className="form-control"
                                placeholder={
                                  isFieldVisible()
                                    ? "Enter employee id"
                                    : "Enter employee id"
                                }
                                isRequired={true}
                                // disabled={action === "Edit"}
                                // value={employeeId}
                                onInput={(event) => {
                                  debouncedValidateEmployeeId(
                                    event?.target?.value,
                                    validateField,
                                    touched,
                                    setTouched
                                  );
                                }}
                              />
                            </div>

                            <div className="input-group myInput mb-32">
                              <p className="h6 mb-2 font-medium">
                                Joining date
                                <span
                                  className="mandatoryFields"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                              </p>
                              <div className="input-group myInput dateCalendar iconbig dateCalendarbgico">
                                {/* <IconCalendar /> */}
                                <DatePicker
                                  name="joiningDate"
                                  selected={values.joiningDate}
                                  onChange={(date) => {
                                    setFieldValue("joiningDate", date);
                                  }}
                                  // minDate={new Date()}
                                />
                                {errors.joiningDate && (
                                  <label
                                    className="errorValidation"
                                    style={{ color: "red" }}
                                  >
                                    {errors.joiningDate}
                                  </label>
                                )}
                              </div>
                            </div>

                            <div className="input-group myInput mb-4">
                              <TextInput
                                name="name"
                                label={
                                  isFieldVisible()
                                    ? "Employee name"
                                    : "Admin name"
                                }
                                className="form-control"
                                placeholder={
                                  isFieldVisible()
                                    ? "Enter employee name"
                                    : "Enter admin name"
                                }
                                isRequired={true}
                                // onChange={handleNameChange}
                                // value={name}
                              />
                              {/* <label>  Employee nam</label>
                                                  <input type="text" className="form-control" placeholder="Enter employee name" /> */}
                            </div>

                            <div className="myInput addUser phoneCountry ee mb-32">
                              {/* <TextInput
                                    name="phoneNumber"
                                    label="Phone number"
                                    className="form-control"
                                    placeholder="Enter phone number"
                                    isRequired={true}
                                    value={values.phoneNumber}
                                  /> */}
                              <label>
                                Phone number
                                <span
                                  className="mandatoryFields"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                              </label>
                              <PhoneInput
                                // className='addUser'
                                defaultCountry="IN"
                                international
                                addInternationalOption={false}
                                placeholder="Phone Number"
                                name="phoneNumber"
                                value={values.phoneNumber}
                                onChange={(e) =>
                                  setFieldValue("phoneNumber", e)
                                }
                                // // onBlur={handleBlur("phoneNumber")}
                                // onBlur={(event) => {
                                //   validatePhoneNumber(
                                //     event?.target?.value,
                                //     validateField,
                                //     touched,
                                //     setTouched
                                //   );
                                // }}
                                onInput={(event) => {
                                  debouncedValidatePhoneNumber(
                                    event?.target?.value,
                                    validateField,
                                    touched,
                                    setTouched
                                  );
                                }}
                                limitMaxLength={25}
                              />
                              {touched.phoneNumber && errors.phoneNumber && (
                                <label
                                  className="errorValidation"
                                  style={{ color: "red" }}
                                >
                                  {errors.phoneNumber}
                                </label>
                              )}
                            </div>

                            <div className="input-group myInput mb-32">
                              <TextInput
                                name="companyEmail"
                                label="Company email address"
                                className="form-control"
                                placeholder="Enter email address"
                                isRequired={true}
                                // onBlur={(event) => {
                                //   validateCompanyEmail(
                                //     event?.target?.value,
                                //     validateField,
                                //     touched,
                                //     setTouched
                                //   );
                                // }}
                                onInput={(event) => {
                                  debouncedValidateCompanyEmail(
                                    event?.target?.value,
                                    validateField,
                                    touched,
                                    setTouched
                                  );
                                }}
                                // disabled={action == "Edit"}
                              />
                            </div>

                            <div className="form-group mySelect mb-32">
                              <label>
                                Gender
                                <span
                                  className="mandatoryFields"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                              </label>
                              <Select
                                name="gender"
                                isSearchable={false}
                                className="select"
                                // classNamePrefix="recatMySel"
                                classNamePrefix="selectCustom"
                                options={genderList}
                                defaultValue={selectedGender}
                                // isDisabled={true}
                                value={selectedGender}
                                onChange={(e) => {
                                  // console.log(e, "eventt");
                                  // setSelectedRoleId(e.value);
                                  onSelectationChange(
                                    e,
                                    "gender",
                                    setFieldValue,
                                    setSelectedGender
                                  );
                                }}
                              />
                            </div>

                            <div className="form-group mySelect mb-32">
                              <label>
                                Role
                                <span
                                  className="mandatoryFields"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                              </label>
                              {userData.role === "Admin" ? (
                                <Select
                                  name="roleId"
                                  isSearchable={false}
                                  className="select"
                                  // classNamePrefix="recatMySel"
                                  classNamePrefix="selectCustom"
                                  options={optionsRole}
                                  defaultValue={selectedRole}
                                  // isDisabled={true}
                                  value={selectedRole}
                                />
                              ) : (
                                <Select
                                  name="roleId"
                                  isSearchable={false}
                                  className="select"
                                  // classNamePrefix="recatMySel"
                                  classNamePrefix="selectCustom"
                                  options={optionsRole}
                                  defaultValue={selectedRole}
                                  value={selectedRole}
                                  onChange={(e) => {
                                    // console.log(e, "eventt");
                                    // setSelectedRoleId(e.value);
                                    onSelectationChange(
                                      e,
                                      "role",
                                      setFieldValue,
                                      setSelectedRole
                                    );
                                  }}
                                />
                              )}
                            </div>

                            <div className="form-group mySelect mb-32">
                              <label>
                                Employment Type
                                <span
                                  className="mandatoryFields"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                              </label>
                              <Select
                                name="employmentType"
                                isSearchable={false}
                                className="select"
                                // classNamePrefix="recatMySel"
                                classNamePrefix="selectCustom"
                                options={optionsEmploymentType}
                                defaultValue={selectedEmploymentType}
                                value={selectedEmploymentType}
                                onChange={(e) => {
                                  // console.log(e, "eventt");
                                  // setSelectedRoleId(e.value);
                                  onSelectationChange(
                                    e,
                                    "employmentType",
                                    setFieldValue,
                                    setSelectedEmploymentType
                                  );
                                }}
                              />
                            </div>
                            {/* )} */}
                            {values.employmentType === 0 && (
                              <div className="input-group myInput mb-32">
                                <p className="h6 mb-2 font-medium">
                                  Probation End Date
                                  <span
                                    className="mandatoryFields"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </p>
                                <div className="input-group myInput dateCalendar iconbig dateCalendarbgico">
                                  {/* <IconCalendar /> */}
                                  <DatePicker
                                    name="probationEndDate"
                                    selected={values.probationEndDate}
                                    onChange={(date) => {
                                      setFieldValue("probationEndDate", date);
                                    }}
                                    minDate={values.joiningDate}
                                  />
                                  {errors.probationEndDate && (
                                    <label
                                      className="errorValidation"
                                      style={{ color: "red" }}
                                    >
                                      {errors.probationEndDate}
                                    </label>
                                  )}
                                </div>
                              </div>
                            )}
                            {values.employmentType === 1 && (
                              <div className="input-group myInput mb-32">
                                <p className="h6 mb-2 font-medium">
                                  Confirmation Date
                                  <span
                                    className="mandatoryFields"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </p>
                                <div className="input-group myInput dateCalendar iconbig dateCalendarbgico">
                                  {/* <IconCalendar /> */}
                                  <DatePicker
                                    name="confirmationStartDate"
                                    selected={values.confirmationStartDate}
                                    onChange={(date) => {
                                      setFieldValue(
                                        "confirmationStartDate",
                                        date
                                      );
                                    }}
                                    minDate={values.joiningDate}
                                  />
                                  {errors.confirmationStartDate && (
                                    <label
                                      className="errorValidation"
                                      style={{ color: "red" }}
                                    >
                                      {errors.confirmationStartDate}
                                    </label>
                                  )}
                                </div>
                              </div>
                            )}
                            <div className="form-group mySelect mb-32">
                              <label>
                                Location
                                <span
                                  className="mandatoryFields"
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                              </label>
                              <Select
                                name="location"
                                isSearchable={false}
                                className="select"
                                // classNamePrefix="recatMySel"
                                classNamePrefix="selectCustom"
                                options={optionsLocation}
                                //defaultValue={selectedLocationType}
                                value={selectedLocationType}
                                onChange={(e) => {
                                  // console.log(e, "eventt");
                                  // setSelectedRoleId(e.value);
                                  onSelectationChange(
                                    e,
                                    "location",
                                    setFieldValue,
                                    setSelectedLocationType
                                  );
                                }}
                              />
                              {/* <TextInput
                                name="location"
                                label="Location"
                                className="form-control"
                                placeholder={
                                  isFieldVisible()
                                    ? "Enter employee location"
                                    : "Enter admin location"
                                }
                                isRequired={true}
                              /> */}
                            </div>

                            {/* {isFieldVisible() && (
                              <> */}
                            {/* <div className="input-group myInput mb-32">
                              <TextInput
                                name="personalEmail"
                                label="Personal email address"
                                className="form-control"
                                placeholder="Enter email address"
                                isRequired={false}
                                // onBlur={(event) => {
                                //   validatePersonalEmail(
                                //     event?.target?.value,
                                //     validateField,
                                //     touched,
                                //     setTouched
                                //   );
                                // }}
                                onInput={(event) => {
                                  debouncedValidatePersonalEmail(
                                    event?.target?.value,
                                    validateField,
                                    touched,
                                    setTouched
                                  );
                                }}
                              />
                            </div> */}

                            {/* )} */}

                            {/* </>
                            )} */}
                          </div>
                          <div className="col-6 col-md-6 col-lg-6">
                            {/* {isFieldVisible() && ( */}
                            <div className="mwidth-440">
                              {/* <div className="mb-32">
                                <TagsInput
                                  inputTags={userData?.tags ?? ""}
                                  onChange={onTagsUpdate}
                                  setMethod={setFieldValue}
                                  touchedMethod={setTouched}
                                  touchedData={touched}
                                />
                                {touched.tags && errors.tags && (
                                  <label
                                    className="errorValidation"
                                    style={{ color: "red" }}
                                  >
                                    {errors.tags}
                                  </label>
                                )}
                              </div> */}
                              {/* 
                              <div className="input-group myInput mb-32">
                                <TextInput
                                  name="title"
                                  label="Designation"
                                  className="form-control"
                                  placeholder={
                                    isFieldVisible()
                                      ? "Enter employee designation"
                                      : "Enter admin designation"
                                  }
                                  isRequired={true}
                                />
                              </div> */}
                              <div className="form-group mySelect mb-32">
                                <label>
                                  Designation
                                  <span
                                    className="mandatoryFields"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </label>
                                <Select
                                  name="title"
                                  isSearchable={false}
                                  className="select"
                                  // classNamePrefix="recatMySel"
                                  classNamePrefix="selectCustom"
                                  options={optionsDesignation}
                                  //defaultValue={selectedDesignationType}
                                  value={selectedDesignationType}
                                  onChange={(e) => {
                                    // console.log(e, "eventt");
                                    // setSelectedRoleId(e.value);
                                    onSelectationChange(
                                      e,
                                      "title",
                                      setFieldValue,
                                      setSelectedDesignationType
                                    );
                                  }}
                                />
                              </div>
                              <div className="form-group mySelect mb-32">
                                <label>
                                  Reporting to
                                  {selectedRole.label === "Employee" && (
                                    <span
                                      className="mandatoryFields"
                                      style={{ color: "red" }}
                                    >
                                      *
                                    </span>
                                  )}
                                </label>
                                <Select
                                  name="reportsTo"
                                  isSearchable={true}
                                  className="select"
                                  classNamePrefix="selectCustom"
                                  // classNamePrefix="recatMySel"
                                  options={optionsUser}
                                  defaultValue={selectedUserList}
                                  value={selectedUserList}
                                  onChange={(e) => {
                                    onSelectationChange(
                                      e,
                                      "reportsTo",
                                      setFieldValue,
                                      setSelectedUserList
                                    );
                                  }}
                                />
                              </div>

                              <div className="form-group mySelect mb-3">
                                <label>
                                  Team
                                  <span
                                    className="mandatoryFields"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </label>
                                <Select
                                  name="teamId"
                                  isSearchable={false}
                                  className="select"
                                  classNamePrefix="selectCustom"
                                  // classNamePrefix="recatMySel"
                                  options={optionsTeam}
                                  defaultValue={selectedTeam}
                                  value={selectedTeam}
                                  onChange={(e) =>
                                    onSelectationChange(
                                      e,
                                      "teamId",
                                      setFieldValue,
                                      setSelectedTeam
                                    )
                                  }
                                />
                              </div>
                              {/* {(userData.role === "Admin" || selectedRole.label === "Admin") && ( */}
                              <div className="cusCheck simpleCheck">
                                <p className="h6 text-gray-200 mwidth-440">
                                  {/* <TextInput
                                        name="isHelpdeskNumber"
                                        label="Mark User as helpdesk member"
                                        type="checkbox"
                                        value={values.isHelpdeskNumber}
                                        disabled={
                                          values.status === "Inactive" || 
                                          (helpdeskNumber === "Helpdesk with the same team exist." ||
                                          helpdeskNumber === "Helpdesk count exceeded.") ||
                                          !((action === "Edit" && values.isHelpdeskNumber === true) || (helpdeskNumber === "Success"))
                                        }
                                        className="checkBoxCheck"
                                      /> */}

                                  <CheckBoxMd
                                    name="isHelpdeskNumber"
                                    text="Mark User as helpdesk member"
                                    value={values.isHelpdeskNumber}
                                    onChange={() => {
                                      setFieldValue(
                                        "isHelpdeskNumber",
                                        !values.isHelpdeskNumber
                                      );
                                    }}
                                    disabled={
                                      values.status === "Inactive" ||
                                      helpdeskNumber?.result ===
                                        "Helpdesk with the same team exist." ||
                                      (userData?.isHelpdeskNumber === false &&
                                        helpdeskNumber?.result ===
                                          "Helpdesk with same team exist.") ||
                                      (userData?.isHelpdeskNumber === false &&
                                        helpdeskNumber?.result ===
                                          "Helpdesk count exceeded.") ||
                                      showHelpDeskError === true
                                      // ||
                                      // !((action === "Edit" && values.isHelpdeskNumber === true) || (helpdeskNumber === "Success"))
                                    }
                                    className="checkBoxCheck"
                                  />
                                  {userData?.isHelpdeskNumber === false &&
                                  selectedTeam.value &&
                                  helpdeskNumber?.result ===
                                    "Helpdesk count exceeded." ? (
                                    <p className="h6 text-secondary-600 pt-2">
                                      Helpdesk members limit has reached. Please
                                      remove an existing one to add new.
                                    </p>
                                  ) : null}
                                </p>
                              </div>

                              {/* {userData.role === "Admin" && selectedRole.label === "Admin" && ( */}
                              <div className="cusCheck simpleCheck pt-1">
                                <p className="h6 text-gray-200 mb-32 mwidth-440 mt-2">
                                  {isVisible &&
                                  userData?.status === "Inactive" ? (
                                    <>
                                      <div
                                        className="d-flex align-items-center justify-content-between m-0 radius-6"
                                        style={{
                                          background: "rgba(74, 21, 75, 0.10)",
                                          padding: "10px 15px",
                                        }}
                                        onClick={handleClose}
                                      >
                                        <p
                                          className="h6 text-primary-200 m-0 p-0"
                                          style={{
                                            width: "calc(100% - 30px)",
                                            marginRight: "12px",
                                          }}
                                        >{`Archived user cannot be added as a helpdesk member.`}</p>
                                        <span className="d-flex align-items-center justify-content-end p-0 btn border-0">
                                          <CrossIconXl />
                                        </span>
                                      </div>
                                    </>
                                  ) : isVisible &&
                                    showHelpDeskError === true ? (
                                    <>
                                      <div
                                        className="d-flex align-items-center justify-content-between m-0 mt-3 radius-6"
                                        style={{
                                          background: "rgba(74, 21, 75, 0.10)",
                                          padding: "10px 15px",
                                        }}
                                        onClick={handleClose}
                                      >
                                        <p
                                          className="h6 text-primary-200 m-0 p-0"
                                          style={{
                                            width: "calc(100% - 30px)",
                                            marginRight: "12px",
                                          }}
                                        >{`'${selectedTeam.label}' team already has a helpdesk member '${helpdeskNumber?.name}(${helpdeskNumber?.email})'. Kindly remove the current selection and try again.`}</p>
                                        <span className="d-flex align-items-center justify-content-end p-0 btn border-0">
                                          <CrossIconXl />
                                        </span>
                                      </div>
                                    </>
                                  ) : null}
                                </p>
                              </div>
                              {/* )} */}

                              <div className="form-group mySelect pb-32 borderBottom">
                                <label>
                                  Timezone
                                  <span
                                    className="mandatoryFields"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </label>
                                <Select
                                  name="timeZoneId"
                                  isSearchable={true}
                                  className="select"
                                  classNamePrefix="selectCustom"
                                  // classNamePrefix="recatMySel"
                                  options={optionsTimezone}
                                  defaultValue={selectedTimeZone}
                                  value={selectedTimeZone}
                                  onChange={(e) => {
                                    onSelectationChange(
                                      e,
                                      "timeZoneId",
                                      setFieldValue,
                                      setSelectedTimeZone
                                    );
                                  }}
                                />
                              </div>

                              {/* <div className="mb-32 pb-32 borderBottom">
                                <p className="h6 mb-2 font-medium">
                                  Joining date
                                  <span
                                    className="mandatoryFields"
                                    style={{ color: "red" }}
                                  >
                                    *
                                  </span>
                                </p>
                                <div className="input-group myInput dateCalendar iconbig dateCalendarbgico">
                                  <IconCalendar />
                                  <DatePicker
                                    name="joiningDate"
                                    selected={values.joiningDate}
                                    onChange={(date) => {
                                      setFieldValue("joiningDate", date);
                                    }}
                                    minDate={new Date()}
                                  />
                                  {errors.joiningDate && (
                                    <label
                                      className="errorValidation"
                                      style={{ color: "red" }}
                                    >
                                      {errors.joiningDate}
                                    </label>
                                  )}
                                </div>
                              </div> */}
                            </div>
                            {/* )} */}
                            {action != "Edit" && (
                              <>
                                <p className="font-bold mb-1">
                                  Login Credentials
                                </p>
                                <p className="h6 fw-normal text-gray-300 mb-4">
                                  Set credentials manually
                                </p>
                              </>
                            )}
                            {action != "Edit" && (
                              <>
                                <div className="input-group myInput mb-4">
                                  <TextInput
                                    disabled
                                    name="userName"
                                    label="Username"
                                    className="form-control"
                                    placeholder="Enter user name"
                                    value={values.companyEmail}
                                    // isRequired={true}
                                    // onFocus={() => {
                                    //   setTitleFocused(true);
                                    // }}
                                    // onBlur={(event) => {
                                    //   validateTitle(
                                    //     event?.target?.value,
                                    //     validateField,
                                    //     touched,
                                    //     setTouched
                                    //   );
                                    // }}
                                  />
                                </div>

                                <div className="input-group myInput mb-12">
                                  <TextInput
                                    name="password"
                                    label="Password"
                                    className="form-control"
                                    placeholder="Enter password"
                                    isRequired={true}
                                  />
                                </div>
                                <p className="h6 text-gray-200 mb-4 mwidth-440">
                                  <CheckBoxMd
                                    name="changePasswordFlag"
                                    text="Change password on first login"
                                    value={values.changePasswordFlag}
                                    onChange={() => {
                                      setFieldValue(
                                        "changePasswordFlag",
                                        !values.changePasswordFlag
                                      );
                                    }}
                                  />
                                </p>
                                {/* {isFieldVisible() && ( */}
                                <div className="mb-3">
                                  <p className="h6 mb-2 font-medium">
                                    Schedule to send invite
                                    <span
                                      className="mandatoryFields"
                                      style={{ color: "red" }}
                                    >
                                      *
                                    </span>
                                  </p>
                                  {/* {isFieldVisible() && ( */}
                                  <div className="input-group myInput dateCalendar iconbig dateCalendarbgico">
                                    {/* <IconCalendar /> */}
                                    <DatePicker
                                      name="inviteDate"
                                      selected={values.inviteDate}
                                      onChange={(date) => {
                                        setFieldValue("inviteDate", date);
                                      }}
                                      minDate={new Date()}
                                    />
                                    {errors.inviteDate && (
                                      <label
                                        className="errorValidation"
                                        style={{ color: "red" }}
                                      >
                                        {errors.inviteDate}
                                      </label>
                                    )}
                                  </div>
                                  {/* )} */}
                                </div>
                                {/* )} */}
                              </>
                            )}

                            {/* {action == "Edit" && (
                              <>
                                <h1>Credentials are Configured.</h1>
                              </>
                            )} */}
                          </div>
                        </div>
                      </Form>
                    )}
                  </Modal.Body>
                  <Modal.Footer className="justify-content-start btnFooter">
                    {action != "Edit" && (
                      <>
                        <Button
                          variant="secondary"
                          className="m-0"
                          type="submit"
                          disabled={
                            Object.keys(userValidation(values)).length !== 0 ||
                            !formDataReady
                          }
                          onClick={() => onUserSubmit()}
                        >
                          Invite User
                        </Button>
                        <Button
                          variant="white"
                          className="m-0 mx-20"
                          onClick={() => {
                            onUserSubmit("invite");
                          }}
                          disabled={
                            Object.keys(userValidation(values)).length !== 0 ||
                            !formDataReady
                          }
                        >
                          Create & Invite Another
                        </Button>
                      </>
                    )}
                    {action == "Edit" && (
                      <Button
                        variant="secondary"
                        className="m-0"
                        type="submit"
                        disabled={
                          Object.keys(userValidation(values)).length !== 0 ||
                          !formDataReady
                        }
                        onClick={() => onUserSubmit("edit")}
                      >
                        Update User
                      </Button>
                    )}
                  </Modal.Footer>
                </>
              );
            }}
          </Formik>
        )}

        {isRestricted && (
          <>
            <Modal.Header>
              <div className="w-100">
                <Modal.Title>Add User</Modal.Title>
              </div>
              <button
                onClick={() => onClose(false)}
                type="button"
                class="btn-close"
                aria-label="Close"
              ></button>
            </Modal.Header>
            <Modal.Body className="">
              <RestrictedPlan
                title={"User Limit Reached!"}
                description={
                  "You have reached the maximum number of users allowed under your current plan. To add more users, upgrade your plan."
                }
              />
            </Modal.Body>
            <Modal.Footer className="justify-content-start btnFooter">
              <Button
                variant="secondary"
                className="m-0"
                type="submit"
                onClick={() => onClose(false)}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </>
        )}
      </>
    )
  );
};

export default AddUserEmployeeModal;
